import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center gap-2" data-id="element-35">
      <p className="text-sm font-semibold text-accent uppercase tracking-wider" data-id="element-36">
        Esta oferta termina en:
      </p>
      <div className="flex gap-3 text-center" data-id="element-37">
        <div className="flex flex-col" data-id="element-38">
          <div className="bg-primary text-white font-display text-3xl md:text-4xl font-bold rounded-lg w-16 h-16 flex items-center justify-center shadow-lg" data-id="element-39">
            {formatNumber(timeLeft.hours)}
          </div>
          <span className="text-xs text-brown-light mt-1 font-medium" data-id="element-40">
            HORAS
          </span>
        </div>
        <div className="text-primary text-3xl font-bold mt-2" data-id="element-41">:</div>
        <div className="flex flex-col" data-id="element-42">
          <div className="bg-primary text-white font-display text-3xl md:text-4xl font-bold rounded-lg w-16 h-16 flex items-center justify-center shadow-lg" data-id="element-43">
            {formatNumber(timeLeft.minutes)}
          </div>
          <span className="text-xs text-brown-light mt-1 font-medium" data-id="element-44">
            MINUTOS
          </span>
        </div>
        <div className="text-primary text-3xl font-bold mt-2" data-id="element-45">:</div>
        <div className="flex flex-col" data-id="element-46">
          <div className="bg-primary text-white font-display text-3xl md:text-4xl font-bold rounded-lg w-16 h-16 flex items-center justify-center shadow-lg" data-id="element-47">
            {formatNumber(timeLeft.seconds)}
          </div>
          <span className="text-xs text-brown-light mt-1 font-medium" data-id="element-48">
            SEGUNDOS
          </span>
        </div>
      </div>
    </div>;
}